import CheckoutOverlay from '../../CheckoutOverlay';
import PayVyneOverlayLazyLoader from './PayVyneOverlayLazyLoader';

function PayVyneOverlay() {
  return (
    <CheckoutOverlay
      popup
      autosize
      stickyHeader
      nopadding
    >
      <PayVyneOverlayLazyLoader />
    </CheckoutOverlay>
  );
}

export default PayVyneOverlay;
